import { defineStore } from "pinia";
import { ref } from "vue";
import type { ContentTab } from "@/utils/goodContentTab";

/**
 * Индикаторы на переключателе вкладок контента (Карточки / Фото / Видео).
 *  - пока в неактивной вкладке идёт генерация — на ней показываем маленький лоадер
 *    (вычисляется из списка товаров прямо в компоненте);
 *  - когда генерация в неактивной вкладке завершилась — ставим «непрочитанную» точку,
 *    которая гаснет при переходе на эту вкладку.
 */
export const useContentTabsIndicators = defineStore("contentTabsIndicators", () => {
  const activeTab = ref<ContentTab>("card");
  const unread = ref<Record<ContentTab, boolean>>({
    card: false,
    images: false,
    video: false,
  });

  /** Текущая открытая вкладка. Переход на вкладку гасит её «непрочитанную» точку. */
  function setActiveTab(tab: ContentTab): void {
    activeTab.value = tab;
    unread.value[tab] = false;
  }

  /** Генерация в указанной вкладке завершилась. Если мы не на ней — зажигаем точку. */
  function markCompleted(tab: ContentTab): void {
    if (tab === activeTab.value) return;
    unread.value[tab] = true;
  }

  function clear(tab: ContentTab): void {
    unread.value[tab] = false;
  }

  return { activeTab, unread, setActiveTab, markCompleted, clear };
});
